/**
 * Espacios interiores extra (line-item/espacio-interior-<id>): una fila por espacio, con su
 * título del anuncio. Si el anfitrión borró el espacio después de la reserva, o el anuncio no
 * viene con la transacción, sale el nombre genérico.
 */
import React from 'react';
import { intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { indoorSpaceTitleForLineItem, isIndoorSpaceLineItem } from '../../util/indoorSpaces';
import { propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemIndoorSpacesMaybe = props => {
  const { lineItems, listing, isProvider, intl } = props;
  const role = isProvider ? 'provider' : 'customer';
  const items = lineItems.filter(
    item => isIndoorSpaceLineItem(item.code) && !item.reversal && item.includeFor.includes(role)
  );

  return items.map(item => {
    const title = indoorSpaceTitleForLineItem(listing, item.code);
    return (
      <div key={item.code} className={css.lineItem}>
        <span className={css.itemLabel}>
          {title
            ? intl.formatMessage({ id: 'OrderBreakdown.indoorSpaceExtraNamed' }, { title })
            : intl.formatMessage({ id: 'OrderBreakdown.indoorSpaceExtra' })}
        </span>
        <span className={css.itemValue}>{formatMoney(intl, item.lineTotal)}</span>
      </div>
    );
  });
};

LineItemIndoorSpacesMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemIndoorSpacesMaybe;
